import React from 'react';

export const Elections = () => {
  return (
    <div>
      <h1>this is the Elections page</h1>
    </div>
  );
};
